import { render, staticRenderFns } from "./dount-chart.vue?vue&type=template&id=8949bc02&scoped=true"
import script from "./dount-chart.ts?vue&type=script&lang=ts&external"
export * from "./dount-chart.ts?vue&type=script&lang=ts&external"
import style0 from "./dount-chart.scss?vue&type=style&index=0&id=8949bc02&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8949bc02",
  null
  
)

export default component.exports